import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@chancenwerk/client/components/chancen-component-card-title.js';
import '@chancenwerk/client/design/components/cr-card.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement board-component-user-pool-card
 */
@customElement('board-component-user-pool-card')
export class ChancenComponentUserPoolCard extends ChemistryLitElement {
  @property() label = 'Nutzer-Pool';
  @property() width = '350px';

  override render() {
    return html` <cr-card
      space="md"
      padding="md"
      ${css({
        width: this.width,
        paddingTop: this.spacing.md,
        paddingBottom: this.spacing.md,
        overflowY: 'auto',
        flex: 1,
        position: 'sticky',
        top: 0,
      })}
    >
      <slot name="overTitle"></slot>
      <chancen-component-card-title> ${this.label} </chancen-component-card-title>
      <slot></slot>
    </cr-card>`;
  }
}
